(function () {
  const initCarousel = (section, style) => {
    const productsEl = section.querySelector('.featured-products__products--carousel');
    if (!productsEl) return null;

    const viewport = productsEl.querySelector('.carousel__viewport');
    if (!viewport) return null;

    const buttons = section.querySelector('.featured-products__buttons');
    const prevBtn = section.querySelector('.featured-products__button--prev');
    const nextBtn = section.querySelector('.featured-products__button--next');
    const pagination = productsEl.querySelector('.featured-products__pagination');

    const isVertical = style === 'vertical';
    const options = isVertical
      ? {
          align: 'start',
          containScroll: 'trimSnaps',
          breakpoints: {
            '(min-width: 750px)': { slidesToScroll: 2 },
            '(min-width: 1200px)': { slidesToScroll: 3 },
          },
        }
      : {
          align: 'start',
          containScroll: 'trimSnaps',
          breakpoints: {
            '(min-width: 989px)': { slidesToScroll: 2 },
            '(min-width: 1359px)': { slidesToScroll: 3 },
          },
        };

    return window.ThemeCarousel.create(viewport, options, [], {
      prev: prevBtn,
      next: nextBtn,
      bullets: pagination ? '.featured-products__pagination' : null,
      onInit: (emblaApi) => {
        productsEl.classList.add('is-initialized');
        const snapCount = emblaApi.scrollSnapList().length;
        if (buttons) {
          buttons.classList.toggle('hide', snapCount <= 1);
        }
      },
    });
  };

  const initSliders = (root) => {
    const sections = root.classList?.contains('featured-products-section')
      ? [root]
      : Array.from(root.querySelectorAll?.('.featured-products-section') || []);

    sections.forEach((section) => {
      const style =
        section.querySelector('.featured-products__products-list--vertical') != null
          ? 'vertical'
          : 'horizontal';

      const viewport = section.querySelector('.carousel__viewport');
      if (viewport) {
        window.ThemeCarousel.destroy(viewport);
      }

      initCarousel(section, style);
    });
  };

  const toggleButton = () => {
    document
      .querySelectorAll('.featured-products__pagination')
      .forEach((element) => {
        const bullets = element.querySelectorAll('.carousel-pagination__bullet');
        const buttons = element.closest('.featured-products__container')?.querySelector(
          '.featured-products__buttons',
        );
        if (buttons) {
          buttons.classList.toggle('hide', bullets.length <= 1);
        }
      });
  };

  const calcHeight = () => {
    const featuredProductsSectionBottom = document.querySelectorAll(
      '.featured-products--bottom',
    );
    featuredProductsSectionBottom.forEach((section) => {
      const card = section.querySelector('.featured-products__products-item');
      const cardWrapper = section.querySelector('.featured-products__products-wrapper');
      const featuredProducts = section.querySelector('.featured-products__products');
      if (section && card) {
        const cardHeight = card.getBoundingClientRect().height;
        const cardWrapperHeight = cardWrapper.getBoundingClientRect().height;
        const bullets = section.querySelector('.featured-products__pagination');

        let bulletsHeight = 0;
        if (bullets) {
          bulletsHeight =
            bullets.getBoundingClientRect().height +
            parseFloat(
              window.getComputedStyle(bullets, null).getPropertyValue('margin-top'),
            );
        }

        let featuredProductsHeight = featuredProducts.getBoundingClientRect().height;
        const marginTop = parseFloat(
          window.getComputedStyle(featuredProducts, null).getPropertyValue('margin-top'),
        );
        featuredProductsHeight += marginTop;

        section.style.paddingBottom = '0';
        section.style.marginBottom = '0';
        section.style.paddingBottom = `${cardHeight / 2 + featuredProductsHeight - cardHeight - bulletsHeight}px`;
        section.style.marginBottom = `${cardHeight / 2 + cardWrapperHeight - featuredProductsHeight}px`;
      }
    });
  };

  const hoverProductList = () => {
    document.querySelectorAll('.featured-products__products-wrapper').forEach((element) => {
      const productList = element.querySelector('.featured-products__products-list');
      const buttons = element.parentElement?.querySelector('.featured-products__buttons');
      if (!productList || !buttons) return;

      productList.addEventListener('mouseenter', () => {
        buttons.classList.add('active');
      });

      productList.addEventListener('mouseleave', (event) => {
        if (
          event.relatedTarget !== buttons.querySelector('.featured-products__button--next') &&
          event.relatedTarget !== buttons.querySelector('.featured-products__button--prev')
        ) {
          buttons.classList.remove('active');
        }
      });

      buttons.querySelectorAll('.carousel-btn').forEach((btn) => {
        btn.addEventListener('mouseleave', () => {
          buttons.classList.remove('active');
        });
      });
    });
  };

  const positionButtons = () => {
    document.querySelectorAll('.featured-products').forEach((section) => {
      const cardItem = section.querySelector('.featured-products__products-item');
      const buttons = section.querySelector('.featured-products__buttons');
      if (cardItem && buttons) {
        buttons.style.top = `${cardItem.getBoundingClientRect().height / 2}px`;
      }
    });
  };

  const resizeFeaturedProducts = () => {
    const featuredProductsSection = document.querySelectorAll(
      '.featured-products-section',
    );

    const sectionResizeObserver = new ResizeObserver(() => {
      featuredProductsSection.forEach((section) => initSliders(section));
      toggleButton();
      setTimeout(calcHeight, 500);
      positionButtons();
      hoverProductList();
    });

    featuredProductsSection.forEach((section) => {
      sectionResizeObserver.observe(section);
      initSliders(section);
    });

    toggleButton();
    setTimeout(calcHeight, 500);
    positionButtons();
    hoverProductList();
  };

  document.addEventListener('shopify:section:load', (event) => {
    initSliders(event.target);
    toggleButton();
    positionButtons();
    hoverProductList();
  });

  resizeFeaturedProducts();
})();
